import { Button, makeStyles, Modal, Input } from "@material-ui/core";
import React, { useEffect, useState } from 'react';
import { db, storage } from '../Firebase';
import "./ProductAdmin.css";
import ProductAdminRow from "./ProductAdminRow"
import Sidebar from './Sidebar';
import logo from '../images/mercado_logo.png'

function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
      height: "300px",
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      height: 200,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));

function ProductAdmin() {
    const [adminProducts, setAdminProducts] = useState([])
    const [open, setOpen] = useState(false)
    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [name, setName] = useState("");
    const [price, setPrice] = useState("");
    const [category, setCategory] = useState("");
    const [rating, setRating] = useState("")
    const [image, setImage] = useState(null);
    const [url, setUrl] = useState("");
    const [progress, setProgress] = useState(0);

    const handleChange = (e) => {
        if (e.target.files[0]) {
          setImage(e.target.files[0]);
        }
    };

    useEffect(()=>{
        db.collection('items').onSnapshot((snapshot)=>{
            setAdminProducts(snapshot.docs.map((doc)=>({
                id:doc.id,
                data:doc.data()
            })))
            
        })
    }, [])
    function getUUID() {
        // eslint gets funny about bitwise
        /* eslint-disable */
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const piece = (Math.random() * 16) | 0;
            const elem = c === 'x' ? piece : (piece & 0x3) | 0x8;
            return elem.toString(16);
        });
        /* eslint-enable */
      }

    const addProduct = ()=>{
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress function ...
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      (error) => {
        // Error function ...
        console.log(error);
      },
      () => {
        // complete function ...
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            setUrl(url);

            db.collection('items').add({
                id: getUUID(),
                title:name,
                price:price,
                rating:rating,
                category:category,
                image:url,
            })
            setOpen(false)
            setProgress(0);
            setImage(null);
          })
      }
    )
}
    
    return (
        <div className="orderAdmin">
            <Modal open={open} onClose={() => setOpen(false)}>
        <div style={modalStyle} className={classes.paper}>
          <form className="app__login">
            <center>
              <img
                className="app__headerImage"
                src={logo}
                alt=""
              />
            </center>

            <Input
              placeholder="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Input
              placeholder="price"
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
             <Input
              placeholder="category"
              type="text"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            />
             <Input
              placeholder="rating"
              type="number"
              value={rating}
              onChange={(e) => setRating(e.target.value)}
            />
            <Input
             placeholder="image"
             type="file"
             onChange={handleChange}
            />
            <br/>
            <progress className="imageupload__progress" value={progress} max="100" />
            <Button onClick={addProduct}>Add Product</Button>
          </form>
        </div>
      </Modal>

            <Sidebar />
          <div className="otherContent">
            <div className="upperContent">
                <div className="header__button">
                   <h2 className="page__header">ProductList</h2>
                   <Button className="add__product"  onClick={()=>setOpen(true)}>Add Product</Button>
                </div>
                <div className="Order__heading">
                    <h3 className="title">Name</h3>
                    <h3 className="price">Price</h3>
                    <h3 className="category">Category</h3>
                    <h3 className="rating">Rating</h3>
                </div>
            </div>
            <div className="orderListContainer">
                {adminProducts.map(({id, data:{title, price, category, rating}})=>(
                    <ProductAdminRow 
                    key={id}
                    title={title} 
                    price={price}
                    category={category}
                    rating={rating}
                    />
                ))} 
                <br />
            </div>
           </div>
            
        </div>
    )
}

export default ProductAdmin
